{
  "common": {
    "actions": {
      "save": "Guardar",
      "edit": "Editar",
      "saveChanges": "Guardar cambios",
      "saveAndExit": "Guardar y salir",
      "cancel": "Cancelar",
      "back": "Atrás",
      "delete": "Eliminar",
      "reject": "Rechazar",
      "accept": "Aceptar",
      "add": "Añadir",
      "applyChanges": "Aplicar cambios",
      "preview": "Vista previa",
      "close": "Cerrar",
      "revert": "Revertir",
      "clickHere": "Haga clic aquí",
      "continue": "Continuar",
      "export": "Exportar",
      "learnMore": "Más información",
      "previous": "Anterior",
      "next": "Siguiente",
      "complete": "Completar",
      "change": "Cambiar"
    },
    "statuses": {
      "canceled": "Cancelado",
      "rejected": "Rechazado",
      "accepted": "Aceptado",
      "success": "Éxito",
      "failed": "Fallido",
      "required": "Obligatorio",
      "open": "Abierto",
      "closed": "Cerrado",
      "imported": "Importado",
      "draft": "Borrador",
      "forReview": "En revisión",
      "forApproval": "En aprobación",
      "approved": "Aprobado",
      "approvalDeclined": "Aprobación rechazada",
      "effective": "Vigente",
      "superseded": "Reemplazado"
    },
    "labels": {
      "archivedRegistryItem": "{{name}} (Archivado)",
      "deactivatedUser": "{{name}} (Desactivado)",
      "name": "Nombre",
      "type": "Tipo",
      "email": "Correo electrónico",
      "password": "Contraseña",
      "comments": "Comentarios",
      "properties": "Propiedades",
      "assignedTo": "Asignado a",
      "eventTitle": "Título del evento",
      "eventId": "ID del evento",
      "none": "Ninguno",
      "reason": "Motivo",
      "events": "Eventos",
      "created": "Creado",
      "lastModified": "Última modificación",
      "steps": "Pasos",
      "fields": "Campos",
      "version": "Versión",
      "owner": "Propietario",
      "eventType": "Tipo de evento",
      "eventTypes": "Tipos de evento",
      "taskStatus": "Estado de la tarea",
      "createdBetween": "Creado entre",
      "due": "Vencimiento",
      "status": "Estado",
      "owners": "Propietarios",
      "startDate": "Fecha de inicio",
      "endDate": "Fecha de finalización",
      "risk": "Riesgo",
      "severity": "Gravedad",
      "ownerEmail": "Correo electrónico del propietario",
      "probability": "Probabilidad",
      "product": "Producto",
      "products": "Productos",
      "rootCause": "Causa raíz",
      "rootCauses": "Causas raíz",
      "relatedRecords": "Relaciones",
      "source": "Origen",
      "assignee": "Responsable",
      "description": "Descripción",
      "visible": "Visible",
      "required": "Obligatorio",
      "title": "Título",
      "prefix": "Prefijo",
      "attachments": "Adjuntos",
      "resolution": "Resolución",
      "relatedTo": "Relacionado con",
      "approvers": "Aprobadores",
      "reviewers": "Revisores",
      "total": "Total",
      "approvalDate": "Fecha de aprobación",
      "id": "ID",
      "tags": "Etiquetas",
      "emptyProducts": "Productos vacíos",
      "emptyRootCauses": "Causas raíz vacías",
      "emptyTags": "Etiquetas vacías",
      "emptySeverities": "Gravedades vacías",
      "emptyProbabilities": "Probabilidades vacías",
      "suppliers": "Proveedores",
      "dueDate": "Fecha de vencimiento",
      "currentDueDate": "Fecha de vencimiento actual",
      "newDueDate": "Nueva fecha de vencimiento",
      "selectANewOwner": "Seleccionar nuevo propietario",
      "tasks": "Tareas",
      "usersList": "Lista de usuarios",
      "createdBefore": "Creado antes de",
      "createdAfter": "Creado después de",
      "dueAfter": "Vencimiento después de",
      "dueBefore": "Vencimiento antes de",
      "resolvedAfter": "Resuelto después de",
      "resolvedBefore": "Resuelto antes de",
      "overdue": "Vencido",
      "onTime": "A tiempo",
      "integrationVariables": "Variables de integración",
      "comment": "Comentario",
      "currentOwner": "Propietario actual",
      "newOwner": "Nuevo propietario",
      "defaultSections": "Secciones predeterminadas",
      "formSteps": "Pasos del formulario",
      "capturedIn": "Capturado en",
      "inSection": "En la sección",
      "open": "Abierto",
      "canceled": "Cancelado",
      "completed": "Completado",
      "templateOwner": "Propietario de la plantilla",
      "timeLimitDays": "Límite de tiempo (días)",
      "validationStepTimeDelayDays": "Retraso de tiempo del paso de validación (días)",
      "newTemplateOwner": "Nuevo propietario de la plantilla",
      "defaultContent": "Contenido predeterminado",
      "sectionWithPosition": "Sección {{position}}",
      "back": "Atrás",
      "moveUp": "Mover arriba",
      "moveDown": "Mover abajo",
      "yes": "Sí",
      "no": "No",
      "view": "Ver",
      "resolved": "Resuelto",
      "closed": "Cerrado",
      "imported": "Importado",
      "manage": "Gestionar",
      "emptyState": "--",
      "order": "Orden",
      "fullName": "Nombre completo",
      "groups": "Grupos",
      "taskName": "Nombre de la tarea",
      "approve": "Aprobar",
      "decline": "Rechazar",
      "revert": "Revertir",
      "eventClosed": "Evento cerrado",
      "stepCompleted": "Paso completado",
      "stepReverted": "Paso revertido",
      "eventReopened": "Evento reabierto",
      "reviewersAssigned": "¡Revisores asignados!",
      "approversAssigned": "¡Aprobadores asignados!",
      "and": "y",
      "content": "Contenido",
      "form": "Formulario",
      "validationWithType": "Validación ({{type}})",
      "reopen": "Reabrir",
      "qualityApproverRequired": "Aprobador de calidad requerido"
    },
    "placeholders": {
      "email": "Correo electrónico...",
      "password": "Contraseña...",
      "enterANumber": "Introduce un número",
      "writeAComment": "Escribe un comentario...",
      "searchFor": "Buscar {{domain}} para añadir...",
      "noResults": "Sin resultados",
      "startTypingToSearchFor": "Empieza a escribir para buscar",
      "newestFirst": "Más nuevos primero",
      "oldestFirst": "Más antiguos primero"
    },
    "errors": {
      "defaultErrorMessage": "Hubo un problema al comunicarse con el servidor.",
      "timeZoneMissingMessage": "No se pudo encontrar la zona horaria del usuario.",
      "invalidCredentials": "Credenciales inválidas",
      "somethingHasGoneWrong": "¡Algo ha salido mal!",
      "currentCompanyRoleError": "No se pudo resolver el rol del usuario en la instancia actual.",
      "failedToFetchEventDetails": "Error al obtener los detalles del evento.",
      "duplicateTitlesNotAllowed": "No se permiten títulos duplicados. Usa títulos únicos.",
      "invalidCharactersInTitle": "Caracteres no válidos en el título: {{characters}}",
      "missingRequiredFieldsClickHere": "Faltan algunos campos obligatorios en el evento. Haz clic aquí para ver los campos obligatorios del evento.",
      "missingRequiredFieldsWithPrefix": "...evento. Haz clic aquí para ver los campos obligatorios del evento.",
      "invalidCharactersInTitlePrefix": "Caracteres no válidos en el título:"
    },
    "notifications": {
      "fileReady": "Archivo listo",
      "preparingFileForDownload": "Preparando archivo para descarga",
      "error": "Error",
      "userReassigned": "Usuario reasignado",
      "eventCreated": "Evento creado",
      "missingInformation": "Información faltante",
      "success": "Éxito",
      "draftDeleted": "Borrador eliminado",
      "draftNotDeleted": "Borrador no eliminado",
      "ownerChanged": "Propietario cambiado",
      "ownerNotChanged": "Propietario no cambiado",
      "eventOpened": "Evento abierto",
      "eventNotOpened": "Evento no abierto",
      "eventUpdated": "Evento actualizado",
      "eventNotUpdated": "Evento no actualizado",
      "taskCompleted": "Tarea completada",
      "taskNotCompleted": "Tarea no completada",
      "failed": "Fallido",
      "tagsUpdated": "Etiquetas actualizadas",
      "tagsNotUpdated": "Etiquetas no actualizadas",
      "eventPropertiesUpdated": "Propiedades del evento actualizadas",
      "newEventCreated": "Nuevo evento creado",
      "eventNotCreated": "Evento no creado",
      "couldNotRetrieveEventMetadata": "No se pudieron obtener los metadatos",
      "couldNotRetrieveGroups": "No se pudieron obtener los grupos",
      "failedToFetchEventTemplateDetails": "Error al obtener la plantilla del evento",
      "eventUpdateFailed": "Error al actualizar el evento",
      "revertedToDraft": "Revertido a borrador",
      "changesSaved": "Cambios guardados",
      "failedToUpdateTask": "Error al actualizar la tarea",
      "couldNotRetrieveTags": "No se pudieron obtener las etiquetas",
      "couldNotRetrieveUsers": "No se pudieron obtener los usuarios",
      "reviewed": "Revisado",
      "stepNotReviewed": "Paso no revisado",
      "eventReassignmentFailed": "Error al reasignar el evento",
      "couldNotRetrieveEventTypes": "No se pudieron obtener los tipos de eventos",
      "failedToFetchFormTemplateDetails": "Error al obtener la plantilla de formulario",
      "formTemplateUpdateFailed": "Error al actualizar la plantilla de formulario",
      "eventTemplateUpdated": "Plantilla de evento actualizada",
      "eventTemplateNotUpdated": "Plantilla de evento no actualizada",
      "newDraftCreated": "Nuevo borrador creado",
      "creatingNewDraftFailed": "Error al crear borrador",
      "templateArchived": "Plantilla archivada",
      "templateArchivingFailed": "Error al archivar la plantilla",
      "templateRestored": "Plantilla restaurada",
      "templateRestoringFailed": "Error al restaurar la plantilla",
      "missingRequiredFields": "Faltan campos obligatorios",
      "temporarilyUnableToRetrieveAllEventProperties": "Temporalmente no se pueden recuperar todas las propiedades del evento",
      "reviewRequest": "Solicitud de revisión",
      "yourReviewIsRequired": "Se requiere tu revisión",
      "fileReadyToDownloadPrefix": "El archivo ya está disponible para",
      "fileReadyToDownloadLinkText": "descargar",
      "couldNotRetrieveSummaryFromAI": "No se pudo obtener el resumen del servicio de IA",
      "propertiesUpdateForEvent": "Propiedades actualizadas para el evento {{eventCode}}",
      "eventCreatedDesc": "Se creó \"{{eventCode}} | {{eventTitle}}\"",
      "eventCreatedWithTitle": "Se creó \"{{title}}\"",
      "tagsUpdatedDesc": "Etiquetas para {{eventCode}} actualizadas correctamente",
      "eventUpdatedToLatestTemplate": "El evento se actualizó a la plantilla de evento más reciente.",
      "eventNotUpdatedToLatestTemplate": "El evento no se actualizó a la plantilla de evento más reciente.",
      "draftSuccessfullyDeleted": "El borrador se eliminó correctamente",
      "failedToDeleteTheDraft": "No se pudo eliminar el borrador",
      "pleaseSaveTheEventTemplateFirst": "Guarda primero la plantilla del evento",
      "wellLetYouKnowWhenFileIsReady": "Te avisaremos cuando el archivo esté listo",
      "exportingEventCodeTitle": "Exportando {{code}} {{title}}",
      "ownerSuccessfullyChanged": "Propietario de {{eventCode}} cambiado correctamente",
      "theTeamHasBeenNotified": "El equipo ha sido notificado. Por favor, actualiza la página o inténtalo más tarde."
    },
    "filters": {
      "filterByOwner": "Filtrar por propietario...",
      "filterByCollaborator": "Filtrar por colaborador...",
      "filterByAssignee": "Filtrar por responsable...",
      "filterByCreatedDate": "Filtrar por fecha de creación...",
      "filterByDueDate": "Filtrar por fecha de vencimiento...",
      "filterByResolvedDate": "Filtrar por fecha de resolución...",
      "filterByDueStatus": "Filtrar por vencimiento...",
      "filterByProduct": "Filtrar por producto...",
      "filterByRootCause": "Filtrar por causa raíz...",
      "filterByTags": "Filtrar por etiquetas...",
      "filterByProbability": "Filtrar por probabilidad...",
      "filterByNameEmailOrGroupName": "Filtrar por nombre, correo o grupo...",
      "filterBySeverity": "Filtrar por gravedad...",
      "searchRelatedRecords": "Filtrar por relaciones...",
      "searchMore": "Buscar más...",
      "filterByStatus": "Filtrar por estado...",
      "filterByEventType": "Filtrar por tipo de evento...",
      "approversAdded": "Aprobadores añadidos",
      "approversRemoved": "Aprobadores eliminados",
      "reviewersAdded": "Revisores añadidos",
      "reviewersRemoved": "Revisores eliminados",
      "reasonForRemovingTheUserType": "Motivo para eliminar los {{userType}}..."
    },
    "tables": {
      "noMatchingEventsFound": "No se encontraron eventos coincidentes",
      "noMatchingTasksFound": "No se encontraron tareas coincidentes"
    },
    "pagination": {
      "show": "Mostrar",
      "showSpace": "Mostrar ",
      "previousPage": "página anterior",
      "nextPage": "página siguiente"
    },
    "exports": {
      "fileReady": "Archivo listo",
      "preparingFileForDownload": "Preparando archivo para descarga",
      "failedToExportTheFile": "Error al exportar el archivo.",
      "xlsx": "XLSX",
      "pdf": "PDF"
    },
    "units": {
      "days": "días"
    },
    "debug": {
      "noFlagsReturnedInThisEnvironment": "No se devolvieron flags en este entorno",
      "knownFlags": "Flags conocidos",
      "rawLDFlagValues": "Valores sin procesar de flags de LD"
    }
  },
  "templates": {
    "steps": {
      "dueDays": {
        "header": "Vencimiento (días)",
        "tooltip": "El número de días tras la creación de un evento a partir de esta plantilla antes de que este paso venza. La cuenta atrás comienza en el momento de la creación del evento.",
        "validation": {
          "range": "Introduzca un número entero de días entre 0 y 100000."
        }
      }
    },
    "labels": {
      "eventTemplates": "Plantillas de eventos",
      "templateStatus": "Estado de la plantilla",
      "templateOwner": "Propietario de la plantilla",
      "defaultAssignee": "Responsable predeterminado",
      "defaultEventOwner": "Propietario predeterminado",
      "defaultTimeLimit": "Límite de tiempo predeterminado",
      "validationStepTimeDelay": "Retraso del paso de validación",
      "timeLimitDays": "Límite de tiempo (días)",
      "validationStepTimeDelayDays": "Retraso del paso de validación (días)",
      "defaultSections": "Secciones predeterminadas",
      "formSteps": "Pasos del formulario",
      "inSection": "En la sección"
    },
    "actions": {
      "editEventTemplate": "Editar plantilla de evento",
      "createTemplateDraft": "Crear borrador de plantilla",
      "makeEffective": "Hacer vigente",
      "addStep": "Añadir paso",
      "deleteDraft": "Eliminar borrador",
      "changeTemplateOwner": "Cambiar propietario de plantilla",
      "createEventTemplate": "Crear plantilla de evento",
      "renameStep": "Renombrar paso",
      "changeValidationStepType": "Cambiar tipo de paso de validación",
      "selectResolution": "Seleccionar resolución",
      "updateTemplate": "Actualizar plantilla",
      "deleteStep": "Eliminar paso",
      "createTemplate": "Crear plantilla",
      "addSection": "Agregar sección",
      "editContentTemplate": "Editar plantilla de contenido"
    },
    "statuses": {
      "draft": "Borrador",
      "effective": "Vigente",
      "archived": "Archivado",
      "forApproval": "Para aprobación",
      "approvalDeclined": "Aprobación rechazada",
      "superseded": "Sustituido",
      "allActiveStatuses": "Todos los estados abiertos"
    },
    "messages": {
      "eventTemplateCreated": "Plantilla de evento creada",
      "templateCreatedWithTitle": "\"{{title}}\" fue creado",
      "eventTemplateCreatedFailTitle": "Plantilla de evento no creada",
      "makeEffectiveSuccessMessage": "La plantilla se hizo vigente",
      "eventTemplateUpdateFailTitle": "Plantilla no actualizada",
      "changeEventTemplateOwnerSuccessMessage": "Propietario de plantilla actualizado",
      "duplicatedStepNames": "¡Nombres de pasos duplicados!",
      "updatesHaveBeenMadeToThisTemplate": "Se han realizado actualizaciones en esta plantilla",
      "pleaseChooseAResolution": "Por favor, elige una resolución para los siguientes cambios de la plantilla. No se aplicará ningún cambio al documento en este momento.",
      "aPrefixWillBeAutomaticallyAdded": "Se añadirá automáticamente un prefijo a cada evento creado.",
      "eachEventMustBeResolved": "Cada evento debe resolverse en el número de días indicado. Este es un valor predeterminado y puede modificarse al crear el evento.",
      "determinesHowManyDays": "Determina cuántos días deben pasar antes de poder completar la aprobación del paso final.",
      "templateSuccessfullyUpdated": "Plantilla actualizada correctamente",
      "failedToUpdateTheTemplate": "No se pudo actualizar la plantilla:",
      "makeThisAResolutionSection": "Hacer de esta una sección de resolución",
      "contentTemplateNotCreated": "La plantilla de contenido no se creó",
      "formTemplateNotCreated": "La plantilla de formulario no se creó",
      "editContentTemplate": "Editar plantilla de contenido",
      "editFormTemplate": "Editar plantilla de formulario",
      "startBuildingYourForm": "Empieza a construir tu formulario",
      "makeThisTheValidationStep": "Establecer como paso de validación",
      "onlyOneResolutionSectionAllowed": "Solo se permite una sección del tipo \"Resolution\". Primero cambia el tipo de la otra sección.",
      "resolutionSectionDescription": "Una sección de tipo \"Resolution\" se presentará como una casilla editable para confirmar si el problema se resolvió o no.",
      "optionalQualityApproverHelper": "Para los pasos donde el Aprobador de Calidad es opcional, se requiere al menos un Otro Aprobador."
    },
    "modals": {
      "makeEffectiveModalHeadingText": "Hacer plantilla vigente",
      "makeEffectiveModalSubText": "Introduzca su firma digital para hacer esta plantilla vigente.",
      "deleteDraftConfirmationHeader": "¿Eliminar borrador?",
      "deleteDraftConformationBody": "¿Seguro que desea eliminar este borrador? Los cambios se perderán.",
      "exportModalTitle": "Exportar event template",
      "exportModalSubText": "Qualio exporta event templates como PDF.",
      "exportCoverPageTitle": "Portada",
      "exportCoverPageSubText": "Una portada incluye las propiedades del event template como la primera página de la exportación del template.",
      "exportIncludeCoverPage": "Incluir portada"
    },
    "fields": {
      "currentEventTemplateOwnerLabel": "Actual",
      "reasonForChangeInputLabel": "Motivo del cambio",
      "reasonForChangePlaceholder": "Añada un motivo para hacer vigente esta plantilla..."
    },
    "helpText": {
      "templateFieldControlDescription": "Muestre los campos que desea recopilar. Los campos obligatorios se verificarán al cerrar el evento.",
      "templateFieldControlDescriptionForEventCapture": "Muestre los campos que desea recopilar. Puede especificar un paso de formulario para capturar el campo.",
      "defaultAssigneeHelper": "Se asignará un propietario automáticamente al crear el evento.",
      "defaultEventOwnerHelper": "Se requiere un propietario predeterminado para crear eventos vía integración.",
      "prefixHelpText": "Prefijo añadido automáticamente a cada evento. Solo letras y números.",
      "defaultTimeLimitDefaultHelpText": "Cada evento debe resolverse en un número de días determinado.",
      "defaultTimeLimitEventDueDateHelpText": "La fecha de vencimiento inicial se calculará basada en este valor.",
      "validationStepTimeDelayHelpText": "Determina cuántos días deben pasar antes de completar la aprobación final."
    },
    "validation": {
      "emptyTitlesAreNotAllowed": "No se permiten títulos vacíos",
      "duplicateTitlesAreNotAllowed": "No se permiten títulos duplicados"
    },
    "ckeditor": {
      "insertCodeBlock": "Insertar bloque de código",
      "insertCodeBlockCaps": "INSERTAR BLOQUE DE CÓDIGO",
      "paragraph": "Párrafo",
      "heading1": "Encabezado 1",
      "heading2": "Encabezado 2",
      "heading3": "Encabezado 3",
      "heading4": "Encabezado 4",
      "normal": "Normal"
    },
    "content": {
      "resolveSection": "La sección '{{sectionTitle}}' está marcada para eliminación, seleccione una resolución."
    }
  },
  "forms": {
    "labels": {
      "fieldTitle": "Título del campo",
      "helpText": "Texto de ayuda",
      "sectionFieldTitle": "Título de la sección",
      "sectionDescription": "Descripción de la sección",
      "defaultContent": "Contenido predeterminado",
      "multiSelect": "Selección múltiple",
      "optionSectionLabel": "Opciones",
      "reviewStep": "Paso de revisión"
    },
    "actions": {
      "completeForm": "Completar formulario",
      "addField": "Añadir campo",
      "addFormElement": "Añadir elemento",
      "createNewField": "Crear nuevo campo",
      "chooseQualioResource": "Elegir recurso de Qualio",
      "addHelpText": "Añadir texto de ayuda",
      "editHelpText": "Editar texto de ayuda",
      "addSectionDescription": "Añadir descripción de sección",
      "editSectionDescription": "Editar descripción de sección",
      "addDefaultContent": "Añadir contenido predeterminado",
      "editDefaultContent": "Editar contenido predeterminado",
      "addOption": "Añadir opción",
      "startBuildingForm": "Empezar a construir el formulario",
      "editForm": "Editar formulario",
      "sendForReview": "Enviar a revisión",
      "sendForApproval": "Enviar para aprobación",
      "reassignStep": "Reasignar paso",
      "manageReviewers": "Gestionar revisores",
      "manageApprovers": "Gestionar aprobadores",
      "revertToDraft": "Revertir a borrador",
      "markAsReviewed": "Marcar como revisado",
      "reassignStepAction": "Reasignar paso"
    },
    "messages": {
      "noFormElementAddedYet": "Aún no se ha añadido ningún elemento del formulario",
      "addFormElementToStartBuilding": "Añade un elemento del formulario para empezar a crear tu formulario",
      "formUpdateSuccessTitle": "Valores actualizados",
      "formUpdateSuccessMessage": "Formulario actualizado con éxito",
      "formUpdateFailedTitle": "Formulario no actualizado",
      "formMissingMessage": "No se pudo encontrar el formulario",
      "formPreviewWarning": "Vista previa del formulario",
      "formPreviewDuplicateLabelWarning": "Etiquetas duplicadas detectadas en el formulario.",
      "noFormYet": "No hay formulario para previsualizar",
      "startFormCopy": "Empiece a construir su formulario para recopilar información específica.",
      "approversUpdateSuccessTitle": "{{approverType}} actualizado",
      "approversUpdateSuccessMessage": "{{approverType}} actualizado con éxito",
      "approversUpdateFailedTitle": "Error al actualizar {{approverType}}",
      "approversUpdateFailedMessage": "Uno o más {{approverType}} no se actualizaron.",
      "atLeastOneAssigneeRequiredMessage": "Se requiere al menos un responsable",
      "removingActionedApproverErrorMessage": "No se puede eliminar un {{approverType}} que ya ha actuado",
      "reviewForm": "Revisar «{{formName}}»",
      "disabledDeleteTooltip": "La visibilidad se define en la plantilla.",
      "disableRequiredTooltip": "La configuración obligatoria se gestiona en la plantilla.",
      "pleaseMarkThisStepAsReviewed": "Marca este paso como revisado",
      "reviewersAdded": "Revisores añadidos"
    },
    "fieldTypes": {
      "text": "Texto de una línea",
      "richText": "Párrafo de texto enriquecido",
      "date": "Fecha",
      "dropdown": "Desplegable",
      "boolean": "Sí / No",
      "numeric": "Numérico",
      "attachment": "Adjunto",
      "document": "Documento",
      "event": "Evento",
      "supplier": "Proveedor",
      "user": "Usuario",
      "section": "Sección",
      "checkbox": "Casillas de verificación",
      "radio": "Botones de opción",
      "changeRequest": "Solicitud de cambio",
      "registry": "Registro",
      "designControls": "Controles de diseño",
      "training": "Formación",
      "documentTemplates": "Plantillas",
      "eventTemplates": "Plantillas de eventos",
      "task": "Tarea"
    },
    "validation": {
      "optionValueRequired": "Valor de opción requerido",
      "optionValueTooLarge": "Debe tener menos de 512 caracteres",
      "optionValueUnique": "Los nombres de opciones deben ser únicos",
      "requiredFieldHelper": "Campo obligatorio para cerrar eventos",
      "formContentInvalidError": "El contenido del formulario no es válido",
      "required": "Obligatorio"
    },
    "statusChanges": {
      "sentForReview": "Enviado a revisión",
      "sentForApproval": "Enviado para aprobación",
      "revertedToDraft": "Revertido a borrador",
      "cannotSendForReview": "No se puede enviar a revisión",
      "cannotSendForApproval": "No se puede enviar para aprobación",
      "cannotRevertToDraft": "No se puede revertir a borrador",
      "cannotUpdateTheForm": "No se puede actualizar el formulario",
      "wasSentForReview": "{{formTitle}} fue enviado a revisión",
      "wasSentForApproval": "{{formTitle}} fue enviado para aprobación",
      "wasRevertedToDraft": "fue revertido a borrador"
    },
    "approvers": {
      "reviewers": "Revisores",
      "qualityApprovers": "Aprobadores de calidad",
      "otherApprovers": "Otros aprobadores",
      "approverDeclinedStepOnDate": "{{approverName}} rechazó este paso el {{date}} con el siguiente comentario:"
    },
    "errors": {
      "cannotSendForApprovalMissingRequiredFields": "Faltan campos obligatorios en el evento",
      "pleaseAddApproversBeforeSubmitting": "Añada aprobadores antes de enviar.",
      "missingRequiredFieldsOnEvent": "Faltan algunos campos obligatorios en el evento.",
      "toViewTheRequiredEventFields": "para ver los campos requeridos."
    }
  },
  "events": {
    "labels": {
      "eventProperties": "Propiedades del evento",
      "relatedEvents": "Eventos relacionados",
      "relatedDocuments": "Documentos relacionados",
      "sourceEvent": "Evento de origen",
      "escalatedTo": "Escalado a",
      "relatedSuppliers": "Proveedores relacionados",
      "events": "Eventos",
      "tasks": "Tareas",
      "products": "Productos",
      "collaborators": "Colaboradores"
    },
    "actions": {
      "createEvent": "Crear evento",
      "editEvent": "Editar evento",
      "openEvent": "Abrir evento",
      "cancelEvent": "Cancelar evento",
      "closeEarly": "Cierre anticipado",
      "updateEvent": "Actualizar evento",
      "updateTags": "Actualizar etiquetas",
      "escalateAndCreateNewEvent": "Escalar y crear nuevo evento",
      "exportEvent": "Exportar evento",
      "changeOwner": "Cambiar propietario",
      "changeDueDate": "Cambiar fecha de vencimiento",
      "updateEventProperties": "Actualizar propiedades del evento",
      "exportListAsXLSX": "Exportar lista como XLSX",
      "exportListAsPDF": "Exportar lista como PDF",
      "approveStep": "Aprobar paso",
      "declineStep": "Rechazar paso",
      "reopenEvent": "Reabrir evento",
      "closeEvent": "Cerrar evento"
    },
    "statuses": {
      "open": "Abierto",
      "closed": "Cerrado",
      "imported": "Importado",
      "rejected": "Rechazado",
      "canceled": "Cancelado"
    },
    "messages": {
      "eventMissingMessage": "No se pudo encontrar el evento",
      "eventAcceptedMessage": "Ha aceptado este evento",
      "eventRejectedMessage": "Ha rechazado este evento",
      "eventCanceledMessage": "Ha cancelado este evento",
      "defaultOwnerNoPermissionTitle": "El propietario no tiene permiso",
      "defaultOwnerNoPermissionMessage": "Derechos insuficientes para el propietario",
      "defaultAssigneeNoPermissionTitle": "El responsable no tiene permiso",
      "defaultAssigneeNoPermissionMessage": "Derechos insuficientes para el responsable",
      "eventPropertiesNotUpdatedError": "Propiedades no actualizadas",
      "missingRequiredFields": "Faltan campos obligatorios",
      "temporarilyUnableToRetrieveAllEventProperties": "Imposible recuperar todas las propiedades actualmente",
      "theTeamHasBeenNotifiedPleaseRefreshOrTryAgainLater": "Se ha notificado al equipo. Por favor, refresque la página.",
      "theFollowingEventFieldsWillBeCopiedToTheNewEvent": "Los siguientes campos se copiarán:",
      "youCanEditEventFieldsAfterCreation": "Podrá editar los campos después de la creación.",
      "provideAnyInformationYouHave": "Proporciona cualquier información que tengas",
      "theFollowingEventFieldsWillBeCopied": "Los siguientes campos del evento se copiarán al nuevo evento:",
      "removedFromProperties": "Eliminado de propiedades:",
      "addedToProperties": "Añadido a propiedades:",
      "requiredColon": "Obligatorio:",
      "notRequired": "No obligatorio:",
      "thisActionAffectsStepApprovalStatus": "Esta acción afecta el estado de aprobación del paso",
      "manageApproverType": "Gestionar {{approverType}}",
      "approvalDeclined": "Aprobación rechazada",
      "manageReviewers": "Gestionar revisores",
      "manageQualityApprovers": "Gestionar aprobadores de calidad",
      "manageOtherApprovers": "Gestionar otros aprobadores",
      "manageApprovers": "Gestionar aprobadores",
      "selectUsersForReviewerFeedback": "Selecciona usuarios para proporcionar comentarios y sugerencias sobre el formulario del evento.",
      "selectUsersForQualityApproval": "Selecciona usuarios que sean obligatorios para la aprobación final del formulario del evento.",
      "selectUsersForOtherApproval": "Selecciona usuarios responsables de la aprobación final y la firma del formulario del evento.",
      "selectUsersForApproval": "Selecciona usuarios responsables de la aprobación final y la firma del formulario del evento.",
      "selectProductForEvent": "Selecciona el producto asociado a este evento.",
      "selectRootCauseForEvent": "Selecciona la causa raíz de este evento.",
      "riskCalculationDescription": "El riesgo se calcula en función de los campos de probabilidad y gravedad de un evento. ",
      "linkSuppliersToEvent": "Vincula proveedores relacionados con este evento. ",
      "canceledOn": "Cancelado el",
      "rejectedOn": "Rechazado el",
      "closedEarlyOn": "Cerrado anticipadamente el",
      "cancelationReason": "Motivo de cancelación",
      "rejectionReason": "Motivo de rechazo",
      "closeReason": "Motivo de cierre",
      "missingQualityTypeApprover": "Falta aprobador de tipo calidad",
      "requiredFieldsMustBeCompletedBeforeApprovalAndClosure": "Los siguientes campos obligatorios deben completarse antes de que este evento pueda aprobarse y cerrarse:",
      "editEventToFillMissingRequiredFields": "Actualiza el evento para completar los campos obligatorios que faltan.",
      "removingApproversWarning": "Eliminar estos aprobadores cambiará el paso de para aprobación a aprobado.",
      "manageCollaborators": "Gestionar colaboradores",
      "selectUsersForCollaboration": "Selecciona usuarios que puedan completar o asignar pasos del evento, así como crear y gestionar tareas.",
      "collaboratorsAdded": "Colaboradores añadidos",
      "collaboratorsRemoved": "Colaboradores eliminados"
    },
    "modals": {
      "eventAcceptSubText": "Firma digital para aceptar el evento",
      "eventCancelSubText": "Esta acción cancelará todos los pasos del evento.",
      "eventRejectSubText": "Firma digital para rechazar el evento",
      "approveStepSubText": "Introduce tu firma digital para aprobar el paso",
      "declineStepSubText": "Introduce tu firma digital para rechazar el paso",
      "closeEarlySubText": "Esta acción cancelará todos los pasos del evento y marcará el evento como cerrado.",
      "reopenEventSubText": "¿Seguro que quieres reabrir este evento?",
      "eventSuccessfullyClosed": "Evento {{eventCode}} cerrado correctamente",
      "eventSuccessfullyReopened": "Evento {{eventCode}} reabierto correctamente",
      "changeDueDateReasonPlaceholder": "Añada un motivo para cambiar la fecha de vencimiento...",
      "dueDateSuccessfullyUpdated": "Fecha de vencimiento actualizada correctamente",
      "collaboratorsSuccessfullyUpdated": "Colaboradores actualizados correctamente"
    },
    "create": {
      "provideRequiredInformationToCreateAnEvent": "Proporcione la información requerida para crear el evento."
    },
    "tabs": {
      "details": "Detalles"
    }
  },
  "tasks": {
    "labels": {
      "taskStatus": "Estado de la tarea",
      "assignTo": "Asignar a",
      "reassignTo": "Reasignar a"
    },
    "actions": {
      "createTask": "Crear tarea",
      "completeTask": "Completar tarea",
      "reopenTask": "Reabrir tarea",
      "completeStep": "Completar paso",
      "actionStep": "Paso de acción",
      "revertStep": "Revertir paso",
      "revertStepCompletion": "¿Revertir la finalización del paso?",
      "assignStep": "Asignar paso",
      "reassign": "Reasignar",
      "assign": "Asignar",
      "comment": "Comentar"
    },
    "modals": {
      "signOffToRevertCompletion": "Firmar para revertir la finalización del paso \"{{stepLabel}}\"",
      "stepCompletionWasReverted": "Se revirtió la finalización del paso \"{{stepLabel}}\"",
      "signOffToCompleteStep": "Firmar para completar el paso \"{{stepLabel}}\"",
      "stepWasMarkedComplete": "El paso \"{{stepLabel}}\" se marcó como completado"
    },
    "messages": {
      "userReassigned": "Usuario reasignado",
      "userReassignedSuccessfully": "Usuario reasignado con éxito.",
      "completeFormAndSendForReview": "Completa el formulario y envíalo para revisión y aprobación cuando esté listo.",
      "noFormAssociatedWithStep": "No hay un formulario asociado con este paso.",
      "thisFieldRequiredBeforeClosing": "Este campo es obligatorio antes de cerrar el evento.",
      "cannotSendForApprovalUntil": "Esta resolución no se puede enviar para aprobación hasta",
      "createAndAssignTasks": "Crea y asigna tareas y haz seguimiento de su progreso.",
      "noTasksAssociatedWithStep": "No hay tareas asociadas con este paso."
    }
  },
  "products": {
    "confirmations": {
      "deleteProductConfirmation": "¿Seguro que desea eliminar «{{productName}}»?"
    }
  },
  "rootCauses": {
    "labels": {
      "rootCauses": "Causas raíz"
    },
    "confirmations": {
      "deleteRootCauseConfirmation": "¿Seguro que desea eliminar la causa raíz «{{rootCauseName}}»?"
    }
  },
  "search": {
    "errors": {
      "searchFailed": "No se pudieron obtener los resultados"
    }
  }
}
